// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1D2X6","unreadBadge":"styles_unreadBadge__1VTnP","modalContent":"styles_modalContent__3N8Ye","modal":"styles_modal__33cQd"};